import { AuditItem } from "./audit.-item.model";
import { Company } from "./company.model";
import { GeoDsMeta } from "./geods-model";
import { Library } from "./library.model";

export class Audit extends GeoDsMeta {
    AuditDate: Date;
    Score?: number;
    MaxScore?: number;
    Percentage?: number;
    Designation: string;
    AllAuditItems?: AuditItem[];
    Library: Library;
    Company: Company;
    ParentId: string;
    IdRefAuditPerson?: string;
}